import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "dashboard__content" }
const _hoisted_3 = { class: "row m-0" }
const _hoisted_4 = { class: "h3 dashboard__title" }
const _hoisted_5 = { class: "row m-0" }
const _hoisted_6 = { class: "account__container" }
const _hoisted_7 = { class: "account__btn-container" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "account__tabs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dashboard_sidebar = _resolveComponent("dashboard-sidebar")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_contact_info = _resolveComponent("contact-info")!
  const _component_change_password = _resolveComponent("change-password")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dashboard_sidebar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.myAccount" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/auth/my-carconnex/my-account/contact-info",
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["btn account__btn", {
                                    'is-active': _ctx.tabActivity === _ctx.myAccountTab.contact,
                                }]),
                  id: "contact",
                  "data-value": "1",
                  onClick: navigate
                }, [
                  _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfo" })
                ], 10, _hoisted_8)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/auth/my-carconnex/my-account/change-password",
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["btn account__btn", {
                                    'is-active':
                                        _ctx.tabActivity === _ctx.myAccountTab.changePassword,
                                }]),
                  id: "documents",
                  "data-value": "3",
                  onClick: navigate
                }, [
                  _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.changePassword" })
                ], 10, _hoisted_9)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.tabActivity === _ctx.myAccountTab.contact)
            ? (_openBlock(), _createBlock(_component_contact_info, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.tabActivity === _ctx.myAccountTab.changePassword)
            ? (_openBlock(), _createBlock(_component_change_password, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}